import * as React from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import * as Guid from "./../../../../common/utils/Guid";
import { containsUnavailableFilters } from "../../../../common/services/FilterService";
import { IFilterData } from "../../../../common/controls/GridHelper/FilterData";
import { FilteringGridWrapper } from "../../../../common/controls/GridHelper/FilterManager";
import { useTranslation } from "react-i18next";
import { InformationDialog } from "../../../../common/controls/GridHelper/InformationDialog";
import { makeStyles } from "@material-ui/core/styles";
import { Icon, IconButton, ListItemIcon, Menu, MenuItem, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
	root: {
		
	},
}));

interface IProps {
	currentFilter: IFilterData,
	grid: FilteringGridWrapper,
	onSaved: () => void,
	manageFiltersPermission: boolean,
}

export default function FilterSaveDialog(props: IProps) {
	const { t } = useTranslation();
	const classes = useStyles();

	const [open, setOpen] = React.useState(false);
	const [name, setName] = React.useState("");
	const [errorName, setErrorName] = React.useState<string>(null);
	const [isPrivate, setIsPrivate] = React.useState(true);
	const [saveAs, setSaveAs] = React.useState(false);

	const [showInfo, setShowInfo] = React.useState<string>(null);

	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	
	function handleSaveBtnClick() {
		fnSaveFilter(false);
	}

	function handleSaveAsBtnClick() {
		fnSaveFilter(true);
	}

	function fnSaveFilter(saveAs: boolean) {
		if (saveAs || !props.currentFilter || Guid.isNullOrEmpty(props.currentFilter.Id)) {
			saveAs = true;
		}

		if (!saveAs && !props.manageFiltersPermission && !props.currentFilter.IsPrivate) {
			saveAs = true;
			return;
		}
		
		let name = "";
		let isPrivate = true;
		if (props.currentFilter) {
			name = props.currentFilter.Name;

			if (props.manageFiltersPermission)
				isPrivate = props.currentFilter.IsPrivate;
		}

		setOpen(true);
		setSaveAs(saveAs);
		setName(name);
		setIsPrivate(isPrivate);
		setErrorName(null);
	}

	function handleNameChange(event) {
		setName(event.target.value);
	}

	function handleIsPrivateChange(event) {
		setIsPrivate(event.target.checked);
	}

	function handleClose() {
		setOpen(false);
	}

	function handleSave() {
		if (!name) {
			setErrorName(t("control.filtering.cannotSaveFilterWithEmptyName"));
			return;
		}

		if (saveAs) {
			props.grid.createFilter(name, isPrivate, "");
		}
		else {
			let currentFilter = props.currentFilter;
			containsUnavailableFilters([currentFilter.Id], (result) => {
				if (result) {
					setShowInfo(t("control.filtering.cannotUpdateFilter"));
				}
				else {
					props.grid.filterUpdate(currentFilter.Id, name, isPrivate, "");
				}
				
			});
		}
		setOpen(false);

		props.onSaved();
	}

	function canSave(): boolean {
		if (!props.currentFilter)
			return false;

		if (props.currentFilter.Predefined)
			return false;

		if (!props.manageFiltersPermission && props.currentFilter && !props.currentFilter.IsPrivate) {
			return false;
		}

		return true;
	}

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleCloseMenu = () => {
		setAnchorEl(null);
	};

	let title = "control.filtering.filterUpdate"
	let actionBtn = "save";
	if (saveAs) {
		actionBtn = "saveAs"
		title = "control.filtering.filterCreation"
	}

	return <div>

		<IconButton onClick={handleClick}>
			<Icon>save</Icon>
		</IconButton>
		<Menu
			anchorEl={anchorEl}
			keepMounted
			open={Boolean(anchorEl)}
			onClose={handleCloseMenu}
		>
			<MenuItem disabled={!canSave()}
				onClick={() => {
				handleCloseMenu();
				handleSaveBtnClick()
				}}
			>
				<ListItemIcon>
					<Icon fontSize="small" >save</Icon>
				</ListItemIcon>
				<Typography variant="inherit">{t("common.action.save")}</Typography>
			</MenuItem>
			<MenuItem
				onClick={() => {
					handleCloseMenu();
					handleSaveAsBtnClick();
				}}>
				<ListItemIcon>
					<Icon fontSize="small" >create</Icon>
				</ListItemIcon>
				<Typography variant="inherit">{t("common.action.saveAs")}</Typography>
			</MenuItem>
		</Menu>
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="form-dialog-title"
		>
			<DialogTitle id="form-dialog-title">{t(title)}</DialogTitle>
			<DialogContent>
				<table className="simpleTable">
					<tbody>
						<tr>
							<td className="item1">
								<span>{t("control.filtering.name")}</span>
							</td>
							<td className="item2">
								{errorName && <p className="text-danger">{t(errorName)}</p>}
								<input value={name} style={{ padding: "7px" }} onChange={handleNameChange} />
							</td>
						</tr>
						{props.manageFiltersPermission &&
							<tr>
								<td className="item1">
								{t("control.filtering.isPrivate")}
								</td>
								<td className="item2 topText">
									<input className="check-box" type="checkbox" checked={isPrivate} onChange={handleIsPrivateChange} />
								</td>
							</tr>
						}
					</tbody>
				</table>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} color="primary">
					{t("common.action.cancel")}
				</Button>
				<Button onClick={handleSave} color="primary">
					{t("common.action."+ actionBtn)}
				</Button>
			</DialogActions>
		</Dialog>
		<InformationDialog
			info={showInfo}
			onClose={() => setShowInfo(null)}
		/>
	</div>
}